import { http } from "./http.js";

async function getLocation(resource, id) {
  const response = await http.get(`${resource}/${id}`);
  return {
    id: response.data.Id,
    code: response.data.Code,
    country: {
      id: response.data.Country.Id,
      isRemoved: response.data.Country.IsRemoved,
      title: response.data.Country.Title,
    },
    region: {
      id: response.data.Region.Id,
      isRemoved: response.data.Region.IsRemoved,
      title: response.data.Region.Title,
    },
    district: response.data.District ? {
      id: response.data.District.Id,
      isRemoved: response.data.District.IsRemoved,
      title: response.data.District.Title,
    } : null,
    city: {
      id: response.data.City.Id,
      isRemoved: response.data.City.IsRemoved,
      title: response.data.City.Title,
    },
  };
}

async function createLocation(resource, entity) {
  const response = await http.post(`/${resource}`, entity);
  return response;
}
async function updateLocation(resource, id, entity) {
  const response = await http.put(`${resource}/${id}`, entity);
  return response;
}

export {
  getLocation,
  createLocation,
  updateLocation,
};